import React, { useState, useEffect } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AnimatedCard from "react-animated-3d-card";
import CardStats from "components/Cards/CardStats.js";
import CardStats1 from "components/Cards/CardStats1.js";

export default function HeaderStats() {
  const quantityTracking =
    "https://img.freepik.com/free-vector/construction-costs-concept-illustration_114360-7458.jpg?t=st=1721732361~exp=1721735961~hmac=85d296b6dbe5afd37cf638a338191ad86d691904f949a06da60e85227aeb4f71&w=740";

  const imageExpenseTracking =
    "https://img.freepik.com/free-vector/app-monetization-concept-illustration_114360-7464.jpg?t=st=1721732425~exp=1721736025~hmac=98c856370277200b48ca3ecdcb7d9432d04844aa2d27f7507c83c3656236f8c6&w=740";

  const notesimage =
    "https://img.freepik.com/free-vector/kanban-board-with-lists-task-time-management-method-project-process-workflow-optimization-organization-kpi-performance-efficiency_335657-2621.jpg?t=st=1721732163~exp=1721735763~hmac=4a798d835930f92df761145cfb1840b26ebc6f2f5f642b8deef8297fcc7f0181&w=740";

  const documentimg =
    "https://img.freepik.com/free-vector/personal-files-concept-illustration_114360-4503.jpg?t=st=1721732258~exp=1721735858~hmac=0797ed21781d6e8f6fe3894aa91b8b8b4a9c2a0dc0eb4c3c1f3731727f256068&w=740";

  const marketingimg =
    "https://img.freepik.com/free-vector/mobile-marketing-isometric-style_23-2148896785.jpg?t=st=1721731780~exp=1721735380~hmac=1970ddde247891977db59d0761c934196032bd0004759fc7c600ff9f2f5536a2&w=740";

  const history = useHistory(); // Get the history object
  const [currency, setCurrency] = useState("");
  const [count, setCount] = useState("");
  const [totalBalance, setTotalBalance] = useState([]);

  //get userid form loca storage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

  //Fetch all data in parallel
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [balanceResponse, currencyResponse, messageCountResponse] =
          await Promise.all([
            fetch(`${BASE_URL}/api/Expense/GetTotalBalance?groupId=${groupId}`),
            fetch(
              `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
            ),
            fetch(
              `${BASE_URL}/api/Expense/MessageCountByGroupID?GroupID=${groupId}`
            ),
          ]);

        const balanceData = await balanceResponse.json();
        const currencyData = await currencyResponse.json();
        const messageCountData = await messageCountResponse.json();

        setTotalBalance(balanceData);
        setCurrency(currencyData.currency);
        setCount(messageCountData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [groupId]);

  // Check if availableBalance is greater than 0
  const isPositiveBalance = totalBalance.availableBalance > 0;

  // Set the color dynamically based on the condition
  const balanceColor = isPositiveBalance ? "rgb(0, 0, 255)" : "red";

  const OnQuantityTrackingClick = () => {
    history.push("/getQuantityTraking");
  };
  const OnMarketingClick = () => {
    history.push("/messageLogs");
  };

  const OnExpenseTrackingClick = () => {
    history.push("/expenses");
  };

  const OnNotesClick = () => {
    history.push("/notes");
  };

  const getDocument = () => {
    history.push("/getDocument");
  };

  return (
    <>
      {/* Header */}

      <div className="relative">
        <div className="mx-auto w-full">
          <div className="flex flex-wrap justify-Raman">
            {/* Card 1 */}
            <div
              className="p-2 lg:p-4 flex-shrink-0"
              style={{ width: "100%", maxWidth: "250px" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={OnExpenseTrackingClick}
              >
                <AnimatedCard
                  config={{
                    rotation: 30,
                    transformSpeed: 1000,
                    transitionSpeed: 600,
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      color: "white",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <img
                      src={imageExpenseTracking}
                      alt="ExpenseTracking"
                      style={{ width: "100%", height: "auto" }}
                    />
                  </div>
                  <h2 className="text-blueGray-700 text-xl font-semibold text-center mb-2">
                    Expense Management
                  </h2>
                </AnimatedCard>
              </div>
            </div>

            {/* Card 2 */}
            <div
              className="p-2 lg:p-4 flex-shrink-0"
              style={{ width: "200%", maxWidth: "250px" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={OnQuantityTrackingClick}
              >
                <AnimatedCard
                  config={{
                    rotation: 30,
                    transformSpeed: 1000,
                    transitionSpeed: 600,
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      color: "white",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <img
                      src={quantityTracking}
                      alt="Quantity Tracking"
                      style={{ width: "100%", height: "auto" }}
                    />
                  </div>
                  <h2 className="text-blueGray-700 text-xl font-semibold text-center mb-2">
                    Quantity Management
                  </h2>
                </AnimatedCard>
              </div>
            </div>

            {/* Card 3 */}
            <div
              className="p-2 lg:p-4 flex-shrink-0"
              style={{ width: "200%", maxWidth: "250px" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={OnNotesClick}
              >
                <AnimatedCard
                  config={{
                    rotation: 30,
                    transformSpeed: 1000,
                    transitionSpeed: 600,
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      color: "white",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <img
                      src={notesimage}
                      alt="Notes Tracking"
                      style={{ width: "100%", height: "auto" }}
                    />
                  </div>
                  <h2 className="text-blueGray-700 text-xl font-semibold text-center mb-2">
                    Notes Management
                  </h2>
                </AnimatedCard>
              </div>
            </div>
            {/* Card 4 */}
            <div
              className="p-2 lg:p-4 flex-shrink-0"
              style={{ width: "100%", maxWidth: "250px" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={getDocument}
              >
                <AnimatedCard
                  config={{
                    rotation: 30,
                    transformSpeed: 1000,
                    transitionSpeed: 600,
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      color: "white",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <img
                      src={documentimg}
                      alt="Your Image"
                      style={{ width: "100%", height: "auto" }}
                    />
                  </div>
                  <h2 class="text-blueGray-700 text-xl font-semibold text-center mb-2">
                    Documents Management
                  </h2>
                </AnimatedCard>
              </div>
            </div>

            {/* Card 5 */}
            <div
              className="p-2 lg:p-4 flex-shrink-0"
              style={{ width: "100%", maxWidth: "250px" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={OnMarketingClick}
              >
                <AnimatedCard
                  config={{
                    rotation: 30,
                    transformSpeed: 1000,
                    transitionSpeed: 600,
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      color: "white",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <img
                      src={marketingimg}
                      alt="Quantity Tracking"
                      style={{ width: "100%", height: "auto" }}
                    />
                  </div>
                  <h2 className="text-blueGray-700 text-xl font-semibold text-center mb-2">
                    Marketing Management
                  </h2>
                </AnimatedCard>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative md:pt-8 pb-16 mt-4">
        <div className=" mx-auto w-full">
          {/* Card stats */}
          <div className="flex flex-wrap">
            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStats
                statSubtitle="Available Balance"
                statTitle={totalBalance.availableBalance}
                currency={currency}
                statPercentColor="text-emerald-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-red-500"
              />
            </div>
            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStats
                statSubtitle="Total Credited"
                statTitle={totalBalance.totalCreatedSum}
                currency={currency}
                statPercentColor="text-orange-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-orange-500"
              />
            </div>
            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStats
                statSubtitle="Total Debited"
                statTitle={totalBalance.totalDebitedSum}
                currency={currency}
                statPercentColor="text-red-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-pink-500"
              />
            </div>
            {/* <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStats1
                statSubtitle="Total Messages Log"
                statTitle={count.toString()}
                count={count} 
                statPercentColor="text-fuchsia-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-teal-500"
              />
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
